import React, { useState } from 'react';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Seccion3';
import Section5 from './Section5';
import Contacto from '../../components/Contacto/Contacto';
import Encuesta9DeJulio from '../../paginas/encuestas/Encuesta9DeJulio';
import ModalEncuesta from '../encuestas/ModalEncuesta';
import styled from 'styled-components';

const Container = styled.div`
  scroll-snap-type: y mandatory;
  overflow-y: scroll;
  height: 100vh;
  width: 100vw; /* Ajustado de 93vw a 100vw */
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Section = styled.div`
  scroll-snap-align: start;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 15px;

  @media (max-width: 768px) {
    margin-bottom: 1px;
  }
`;

const Inicio = () => {
  const [mostrarModal, setMostrarModal] = useState(true);

  return (
   <>
  {/* 
  {mostrarModal && (
    <ModalEncuesta onClose={() => setMostrarModal(false)}>
      <Encuesta9DeJulio onClose={() => setMostrarModal(false)} />
    </ModalEncuesta>
  )}
  */}

  <Container>
    <Section>
      <Section1 />
    </Section>
    <Section>
      <Section2 />
    </Section>
    <Section>
      <Section3 />
    </Section>
    <Section>
      <Section5 />
    </Section>
    <Section>
      <Contacto />
    </Section>
  </Container>
</>

  );
};

export default Inicio;
